<template>
  <div class="advWrap">
   <div
     style="width: 320px;height: 56px;font-size: 40px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #1F2329;line-height: 56px;margin: 0 auto;">
     {{mk3.title}}</div>
   <div class="advMain">
     <div class="leftBlock">
       <h3 class="title">{{mk3.subtitle}}</h3>
       <p class="message">
         {{mk3.content}}
       </p>
       <div
         style="width: 150px;height: 50px;border-radius: 40px;background: #fff;text-align: center;line-height: 50px;margin-top: 40px;background: linear-gradient(to bottom right, #02B4E0 40%, #14E1A0 99%);color: #fff;letter-spacing: 2px;cursor: pointer;" @click="childMethod">
         {{mk3.buttonName}}</div>
       <!-- <div class="buttonWrap"><Mybutton @clickFn="showForm">了解国家标识</Mybutton></div> -->
     </div>
     <div class="rightBlock">
       <transition name="gxb">
         <img class="gxb" src="../../assets/images/gxb.png" />
       </transition>
       <transition name="fdj">
          <img class="fdj" src="../../assets/images/fdj.png" />
       </transition>
     </div>
   </div>
  </div>
</template>
<script>
import {
    getIndex
  } from '@/api/api'
  import {serverUrl} from '@/utils/server'
export default {
  name: 'codeAdv',
  components: {
    // Mybutton
  },
  props: {

  },
  data () {
    return {
      baseURL: '',
      mk3: {}
    }
  },
  methods: {
    setIndex() {
      getIndex().then(res=> {
          this.mk3 = res.mk3
      })
    },
    childMethod () {
    			this.$emit('fatherMethod');
    		}
  },
  mounted() {
    this.baseURL = serverUrl.baseURL
    this.setIndex()
  }
}
</script>
<style scoped lang="scss">
/**放大镜动画**/
.fdj{
  position: absolute;
  left: 403px;
  top: 156px;
  // animation: fdj-in-out 3s ease-in-out .1s infinite
}
.fdj-enter-active {
  animation: fdj-in-out 1s;
  animation-delay: .1s;
}
.fdj-leave-active {
  animation: fdj-in-out .3s reverse;
  animation-delay: 0;
}

@keyframes fdj-in-out {
  0% {
    left: 403px;
    top: 156px;
    opacity: 1;
    transform: scale(0.5)
  }
  60%{
    left: 600px;
    top: 120px;
    opacity: 1;
  }
  // 100% {
  //   left: 403px;
  //   top: 156px;
  //   opacity: 1;
  //   transform: scale(1)
  // }
}

/**工信部动画**/
.gxb{
  position: absolute;
  top: 109px;
  left: 508px;
  // animation: gxb-in-out 3s ease-in-out .1s infinite
}
.gxb-enter-active {
  animation: gxb-in-out .4s;
  animation-delay: .3s;
}
.gxb-leave-active {
  // animation: gxb-in-out 0 reverse;
  // animation-delay: 0;
}

@keyframes gxb-in-out {
  0% {
    transform: scale(0.7);
    opacity: 0;
  }
  // 30% {
  //   transform: scale(0.7);
  // }
  // 60%{
  //   // transform: scale(1);
  //   opacity: 1;
  // }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.advWrap{
  height: 720px;
  width: 100%;
  margin: 0 auto;
  padding: 0 100px;
  box-sizing: border-box;
  padding: 66px 0 115px;
  .advMain{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    // width: 1440px;
    padding: 0 80px;
    margin: 0 auto;
    // padding-bottom: 110px;
    margin-top: 175px;
    .leftBlock{
      .title{
        font-size: 40px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: normal;
        color: #1F2329;
        line-height: 56px;
      }
      .message{
        font-size: 18px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: normal;
        color: #36444D;
        line-height: 28px;
        width: 400px;
      }
      .buttonWrap{
        margin-top: 50px;
      }
    }
    .rightBlock{
      width: 670px;
      height: 316px;
      background: url('../../assets/images/bg_3.png') top left no-repeat;
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/CodeAdv.vue